import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {SupplierSearchPageComponent} from "../supplier-search-page/supplier-search-page.component";

export class SupplierReportSelectionData extends EntityData<SupplierReportSelectionData> {
    @identifier vendorId: number;
    @field name: string;
}

@Component({
    selector: "wbo-supplier-report-selection",
    templateUrl: "./supplier-report-selection-control.component.html"
})
export class SupplierReportSelectionControlComponent {

    SupplierSearchPageComponent = SupplierSearchPageComponent;

    fieldName: string = "suppliers";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromSupplier(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((supplier: any) => supplier.vendorId === item.vendorId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
